"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var AlertIcon = function AlertIcon(props) {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "35px",
    height: "35px",
    "aria-labelledby": "alert-title",
    role: "img"
  }, _react["default"].createElement("title", {
    id: "alert-title"
  }, "Set Rate Alert"), _react["default"].createElement("ellipse", {
    className: "cls-1 hvr-icon-fill",
    cx: "9.14",
    cy: "21.25",
    rx: "1.27",
    ry: "1.25",
    fill: "#fff"
  }), _react["default"].createElement("path", {
    className: "cls-2 hvr-icon-stroke",
    d: "M6.43,20.39l-.87-.29.87-.87A18.94,18.94,0,0,0,11,11.83l.72-2.16a5.56,5.56,0,0,1,7-3.52h0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }), _react["default"].createElement("path", {
    className: "cls-2 hvr-icon-stroke",
    d: "M18.76,6.16h0a5.56,5.56,0,0,1,3.52,7l-.72,2.16A18.94,18.94,0,0,0,20.78,24L21,25.23l-9.08-3",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }), _react["default"].createElement("path", {
    className: "cls-2 hvr-icon-stroke",
    d: "M18.36,6l.13-.4a.42.42,0,1,1,.81.27l-.13.4",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }), _react["default"].createElement("circle", {
    className: "cls-1 hvr-icon-fill",
    cx: "15.55",
    cy: "24.53",
    r: "1.7",
    fill: "#fff"
  }));
};

var _default = AlertIcon;
exports["default"] = _default;